import React from "react";

const QuoteIcon = () => (
  <svg
    className="mx-auto mb-6 h-12 text-purple-600 dark:text-purple-400"
    viewBox="0 0 24 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M14.017 18V10.609C14.017 4.905 17.748 1.039 23 0L23.995 2.151C21.563 3.068 20 5.789 20 8H24V18H14.017ZM0 18V10.609C0 4.905 3.748 1.038 9 0L9.996 2.151C7.563 3.068 6 5.789 6 8H9.983V18H0Z"
      fill="currentColor"
    />
  </svg>
);

const Testimonial = () => {
  return (
    <section className="bg-gray-50 dark:bg-gray-800">
      <div className="mx-auto max-w-screen-xl px-4 py-12 text-center lg:px-6 lg:py-24">
        <figure className="mx-auto max-w-screen-md">
          {/* Quote Icon */}
          <QuoteIcon />

          {/* Testimonial */}
          <blockquote>
            <p className="text-xl font-medium leading-relaxed text-gray-900 md:text-2xl dark:text-white">
              “ZeedBio made it incredibly easy to share everything I do with my
              audience. Instead of sending multiple links, I now have one
              beautiful page for my social media, website, products and all my
              important content.”
            </p>
          </blockquote>

          {/* User */}
          <figcaption className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-3">
            {/* Avatar */}
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-purple-600 text-lg font-bold text-white shadow-lg">
              Z
            </div>

            {/* User Information */}
            <div className="flex flex-col items-center gap-1 sm:flex-row sm:divide-x-2 sm:divide-gray-300 dark:sm:divide-gray-700">
              <div className="font-semibold text-gray-900 sm:pr-3 dark:text-white">
                ZeedBio Creator
              </div>

              <div className="text-sm font-light text-gray-500 sm:pl-3 dark:text-gray-400">
                Creator & Entrepreneur
              </div>
            </div>
          </figcaption>
        </figure>
      </div>
    </section>
  );
};

export default Testimonial;